// src/api/connectionApi.js
import { api } from "./client";

export const connectionApi = {
  list: (include_inactive = false) =>
    api.get("/codebase/connections", { params: { include_inactive } }),

  get: (id) => api.get(`/codebase/connections/${id}`),

  create: (payload) => api.post("/codebase/connections", payload),

  update: (id, payload) => api.put(`/codebase/connections/${id}`, payload),

  // body is optional (advanced overrides)
  test: (id, body = null) => api.post(`/codebase/connections/${id}/test`, body || {}),
};
